import "./style-v2.css";

export type IAppTabV2 = {
  id: number | string;
  label: string;
  onClick?: () => void;
  disabled?: boolean;
};

type IAppTabsV2Props = {
  tabs: IAppTabV2[];
  tabIndex?: number;
  setTabIndex?: (i: number) => void;
  onTabChange?: (index: number) => void;
  className?: string;
  activeClassName?: string;
  inactiveClassName?: string;
};

const AppTabsV2 = ({
  tabs,
  tabIndex,
  setTabIndex,
  onTabChange,
  className,
  activeClassName,
  inactiveClassName,
}: IAppTabsV2Props) => {
  return (
    <div className={`app-tabs-v2 ${className || ""}`.trim()}>
      {tabs.map((tab, index) => (
        <div
          key={tab.id || index}
          className={`app-tab-v2 ${tab.disabled ? "disabled" : ""} ${
            tabIndex === index ? `active ${activeClassName || ""}` : `inactive ${inactiveClassName || ""}`
          }`.trim()}
          onClick={() => {
            if (tab.disabled) return;
            setTabIndex && setTabIndex(index);
            onTabChange && onTabChange(index);
            tab.onClick && tab.onClick();
          }}
        >
          <span className="app-tab-v2-label">{tab.label}</span>
          {tabIndex === index && <div className="app-tab-v2-underline" />}
        </div>
      ))}
    </div>
  );
};

export default AppTabsV2;
